// types/schedules.ts
import { Device } from './devices';
import { Playlist } from './playlists';

export type DayOfWeek = 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';

export interface DeviceSchedule {
    scheduleId: number;
    deviceId?: number;
    playlistId?: number;
    startTime?: string;
    endTime?: string;
    daysOfWeek: string;
    priority: number;
    active?: boolean;
    device?: Device;
    playlist?: Playlist;
}

export interface CreateScheduleRequest {
    deviceId: number;
    playlistId: number;
    startTime?: string;
    endTime?: string;
    daysOfWeek: string;
    priority?: number;
    active?: boolean;
}

export interface UpdateScheduleRequest {
    deviceId?: number;
    playlistId?: number;
    startTime?: string;
    endTime?: string;
    daysOfWeek?: string;
    priority?: number;
    active?: boolean;
}

export interface ScheduleValidationError {
    field: string;
    message: string;
}

export const DAYS_OF_WEEK: DayOfWeek[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const validateSchedule = (schedule: CreateScheduleRequest | UpdateScheduleRequest): ScheduleValidationError[] => {
    const errors: ScheduleValidationError[] = [];

    if ('deviceId' in schedule && !schedule.deviceId) {
        errors.push({ field: 'deviceId', message: 'Device is required' });
    }

    if ('playlistId' in schedule && !schedule.playlistId) {
        errors.push({ field: 'playlistId', message: 'Playlist is required' });
    }

    if (schedule.daysOfWeek) {
        const days = schedule.daysOfWeek.split(',').map(d => d.trim());
        const invalidDays = days.filter(day => !DAYS_OF_WEEK.includes(day as DayOfWeek));
        if (invalidDays.length > 0) {
            errors.push({ 
                field: 'daysOfWeek', 
                message: `Invalid days: ${invalidDays.join(', ')}` 
            });
        }
    }

    if (schedule.startTime && schedule.endTime) {
        const start = new Date(`2000-01-01T${schedule.startTime}`);
        const end = new Date(`2000-01-01T${schedule.endTime}`);
        if (start >= end) {
            errors.push({ 
                field: 'timeRange', 
                message: 'End time must be after start time' 
            });
        }
    }

    if (schedule.priority && (schedule.priority < 1 || schedule.priority > 100)) {
        errors.push({ 
            field: 'priority', 
            message: 'Priority must be between 1 and 100' 
        });
    }

    return errors;
};